import { render, staticRenderFns } from "./DistanceMatrix.vue?vue&type=template&id=360afcfc&"
import script from "./DistanceMatrix.vue?vue&type=script&lang=js&"
export * from "./DistanceMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports